// This file was auto-generated by Fern from our API Definition.
export const FetchSimpleTestsetToFileRequestFileType = {
    Csv: "csv",
    Json: "json",
};
